import { setZoom } from "../../Store/reducers/fabriccontrolsSlice";
import { setDimensions,setPixiZoom } from "../../Store/reducers/pixiCanvasSlice";

export const useZoomControls = ({
                                    dispatch,
                                    zoom,
                                    pixiZoom,
                                    fabricCanvas,
                                    activeTab,
                                    pixiCanvas,
                                }) => {
    let animationFrameId = null; 

    const handleZoom = (relativeZoom) => {

        if (fabricCanvas && activeTab !== "editMockup") {
            dispatch(setZoom(relativeZoom));
        } else if ( pixiCanvas  || (fabricCanvas && activeTab === "editMockup" && activeTab !== "editSVG")) {
            dispatch(setPixiZoom(relativeZoom));
        }
        // dispatch(setPixiZoom(relativeZoom));

        if (fabricCanvas  && activeTab !== "previewMockup" ) {
            const center = new fabric.Point(
                fabricCanvas.getWidth() / 2,
                fabricCanvas.getHeight() / 2
            );
            fabricCanvas.zoomToPoint(center, relativeZoom);
            fabricclampViewport(fabricCanvas);
        }else if (pixiCanvas && activeTab === "previewMockup") {
            const screenWidth = pixiCanvas.screen?.width;
            const screenHeight = pixiCanvas.screen?.height;
            const cameraContainer = pixiCanvas.cameraContainer;
          
            if (!screenWidth || !screenHeight || !cameraContainer) return;
          
            const centerX = screenWidth / 2;
            const centerY = screenHeight / 2;
          
            const previousZoom = cameraContainer.scale.x || 1;
            const newZoom = relativeZoom;
          
            const ratio = newZoom / previousZoom;
          
            const dx = (cameraContainer.pivot.x - centerX) * ratio;
            const dy = (cameraContainer.pivot.y - centerY) * ratio;
          
            cameraContainer.pivot.set(centerX + dx, centerY + dy);
            cameraContainer.scale.set(newZoom, newZoom);
          
            clampPivot(cameraContainer, screenWidth, screenHeight);
            dispatch(setPixiZoom(newZoom));
            dispatch(setDimensions({ width: screenWidth, height: screenHeight }));
          
            if (animationFrameId) {
              cancelAnimationFrame(animationFrameId);
            }
            animationFrameId = requestAnimationFrame(() => {
              pixiCanvas.render();
            });
          }
          
    };

  const zoomIn = () => {
    // pick the base value
    const base = activeTab === "editSVG" ? zoom : pixiZoom;
    handleZoom(base + 0.1);
  };

  const zoomOut = () => {
    const base = activeTab === "editSVG" ? zoom : pixiZoom;
    const newZoom = base - 0.1;
    if (newZoom <= 0.3) return;
    handleZoom(newZoom);
  };

    return { zoomIn, zoomOut };
};

export const clampPivot = (cameraContainer, screenWidth, screenHeight) => {
    const scale = cameraContainer.scale.x;
    const visibleWidth = screenWidth / scale;
    const visibleHeight = screenHeight / scale;
    const halfVisibleX = visibleWidth / 2;
    const halfVisibleY = visibleHeight / 2;
    const contentWidth = screenWidth;
    const contentHeight = screenHeight;

    if (visibleWidth >= contentWidth) {
        cameraContainer.pivot.x = contentWidth / 2;
    } else {
        cameraContainer.pivot.x = Math.max(
            halfVisibleX,
            Math.min(cameraContainer.pivot.x, contentWidth - halfVisibleX)
        );
    }
    if (visibleHeight >= contentHeight) {
        cameraContainer.pivot.y = contentHeight / 2;
    } else {
        cameraContainer.pivot.y = Math.max(
            halfVisibleY,
            Math.min(cameraContainer.pivot.y, contentHeight - halfVisibleY)
        );
    }
};

export function fabricclampViewport(canvas, activeTab, zoomValue) {
  const canvasWidth = canvas.getWidth();
  const canvasHeight = canvas.getHeight();
  let vpt = canvas.viewportTransform;

  const zoom =
    activeTab === "editMockup" || activeTab === "previewMockup"
      ? zoomValue // pixiZoom
      : canvas.getZoom(); // default for editSVG

  if (zoom <= 1) {
    // Center canvas when zoomed out
    vpt[4] = (canvasWidth - canvasWidth * zoom) / 2;
    vpt[5] = (canvasHeight - canvasHeight * zoom) / 2;
  } else {
    // Clamp panning when zoomed in
    const minX = canvasWidth - canvasWidth * zoom;
    const minY = canvasHeight - canvasHeight * zoom;
    const maxX = 0;
    const maxY = 0;
    if (vpt[4] > maxX) vpt[4] = maxX;
    if (vpt[4] < minX) vpt[4] = minX;
    if (vpt[5] > maxY) vpt[5] = maxY;
    if (vpt[5] < minY) vpt[5] = minY;
  }

  canvas.setViewportTransform(vpt);
}


